import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { AlertController, IonApp, NavController, Platform, ToastController } from '@ionic/angular';
import { Observable, Subscriber, of, BehaviorSubject } from 'rxjs';
import * as global from '../../globals';
import { PushServerInfo } from '../../data/push-server-info';
import OneSignal from 'onesignal-cordova-plugin';
// import { OneSignal, OSNotification, OSNotificationOpenedResult, OSNotificationPayload } from '@awesome-cordova-plugins/onesignal';
// declare let OneSignal: any;

import { GotoPageHandlerInterface, PushNotificationHandler } from './pushnotification-handler';
// import { Dialogs } from '@awesome-cordova-plugins/dialogs';
import { MyGolfStorageService } from '../../storage/mygolf-storage.service';
import {
  ActionPerformed,
  PushNotifications,
  PushNotificationSchema,
  Token,
} from '@capacitor/push-notifications';
import { MessageDisplayUtil } from 'src/message-display-utils';
import { FirebaseMessaging } from '@capacitor-firebase/messaging';
import { ClubFlightService } from 'services/club-flight-service/club-flight-service';
import * as moment from 'moment';

import { Component, OnInit } from '@angular/core';
// Firebase Web SDK disabled for iOS compatibility
// import { getToken, onMessage } from 'firebase/messaging';
// import { messaging } from 'src/main';
import { environment } from 'src/environments/environment';

// import {OSNotification, OSNotificationOpenedResult} from "./onesignal-notification-data";
/*
 Generated class for the PushNotification provider.

 See https://angular.io/docs/ts/latest/guide/dependency-injection.html
 for more info on providers and Angular 2 DI.
 */
@Injectable()
export class PushNotificationService {
  private subscribers: Array<Subscriber<any>> = [];

  private handler: PushNotificationHandler;

  hasNewNotification = new BehaviorSubject<boolean>(false);
  constructor(
    private platform: Platform,
    // private dialogs: Dialogs,
    // private oneSignal: OneSignal,
    private storage: MyGolfStorageService,
    private toastCtrl: ToastController,
    private flightService: ClubFlightService
  ) {
    this.handler = new PushNotificationHandler();

    this.initFCM();
  }

  public setControllers(
    app: IonApp,
    nav: NavController,
    alertCtl: AlertController,
    toastCtl: ToastController,
    gotoPageHandler?: GotoPageHandlerInterface
  ) {
    this.handler.setControllers(
      app,
      // this.dialogs,
      nav,
      alertCtl,
      toastCtl,
      this.platform,
      gotoPageHandler
    );
  }
  public registerDevice(pushServerInfo: PushServerInfo) {
    //Return true if the device isn't a mobile device
    // if(!this.platform.is('capacitor')) return;
    //Now register the device
    if (pushServerInfo?.appKey) {
      OneSignal.Debug.setLogLevel(6);
      // Initialize with your OneSignal App ID
      OneSignal.initialize(pushServerInfo?.appKey);
      // console.debug('one signal init', appId);
      // Use this method to prompt for push notifications.
      // We recommend removing this method after testing and instead use In-App Messages to prompt for notification permission.
      OneSignal.Notifications.requestPermission(true).then((accepted: boolean) => {
        console.log('User accepted notifications: ' + accepted);
      });

      OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
        console.log('OneSignal: NOTIFICATION WILL DISPLAY:', JSON.stringify(event));
        console.table(event);

        const notification = event.getNotification();
        console.log('notification: ', notification);

        // Get custom data from the notification
        const data = notification.additionalData;
        console.log('Additional data: ', data);

        this.onNotification(event, true);

        // You can either:

        // Option 1: Display the notification
        // event.complete(notification);

        // Option 2: Prevent display but handle it yourself
        // event.complete(null);

        // Parse and handle the notification data here
        // this.handleNotificationData(notification);
      });

      // 2. When a notification is tapped by the user
      OneSignal.Notifications.addEventListener('click', event => {
        console.log('OneSignal: NOTIFICATION CLICKED:', event);
        this.onNotification(event, false);
      });
    }
    if (pushServerInfo && pushServerInfo.appKey && pushServerInfo.googleProjectNumber) {
      // this.oneSignal.startInit(pushServerInfo.appKey, pushServerInfo.googleProjectNumber);
      // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);
      // // InAppAlert
      // // None
      // this.oneSignal.handleNotificationReceived()
      //     .subscribe((notification: OSNotification) => {
      //         this.onNotification(notification, true);
      //     });
      // this.oneSignal.handleNotificationOpened()
      //     .subscribe((notfOpenedResult: OSNotificationOpenedResult)=>{
      //         this.onNotification(notfOpenedResult.notification, false);
      //     });
      // this.oneSignal.endInit();
    }
  }
  public tagPlayer(playerId: number) {
    OneSignal.User.addTags({
      playerId: playerId,
    });
    // this.oneSignal.sendTags({
    //     playerId: playerId + ""
    // });
  }
  public initPlayer(pushServerInfo: PushServerInfo, playerId: number): Observable<boolean> {
    if (!this.platform.is('mobile')) {
      return of(false);
    }
    if (!OneSignal) {
      return of(false);
    }
    if (pushServerInfo && pushServerInfo.appKey && pushServerInfo.googleProjectNumber) {
      if (!global.SharedObject['OneSignalRegistered']) {
        OneSignal.initialize(pushServerInfo.appKey);

        OneSignal.Notifications.addEventListener('foregroundWillDisplay', event => {
          this.onNotification(event, true);
        });

        OneSignal.Notifications.addEventListener('click', event => {
          console.log('OneSignal: NOTIFICATION CLICKED:', event);
          this.onNotification(event, false);
        });
        // this.oneSignal.startInit(pushServerInfo.appKey, pushServerInfo.googleProjectNumber);
        // this.oneSignal.inFocusDisplaying(this.oneSignal.OSInFocusDisplayOption.None);
        // this.oneSignal.handleNotificationReceived()
        //          .subscribe((notification: OSNotification) => {
        //              this.onNotification(notification, true);
        //          });
        // this.oneSignal.handleNotificationOpened()
        //          .subscribe((notfOpenedResult: OSNotificationOpenedResult)=>{
        //             this.onNotification(notfOpenedResult.notification, false);
        //          });
        // this.oneSignal.endInit();

        global.SharedObject['OneSignalRegistered'] = true;
      }

      //   OneSignal.enableNotificationsWhenActive(false);
      //   OneSignal.enableInAppAlertNotification(false);
      //Tag the user with player id
      OneSignal.User.addTags({
        playerId: playerId,
      });
      // this.oneSignal.sendTags({
      //     playerId: playerId + ""
      // });
      return of(true);
    } else {
      return of(false);
    }
  }

  checkNotification() {
    return this.hasNewNotification.asObservable();
  }

  setHasNotification(set: boolean) {
    this.hasNewNotification.next(set);
  }

  private onNotification(data: any, appActive: boolean) {
    // OSNotification

    //Handle the push notification
    let _payload = [];

    this.storage.getPreference('notifications').subscribe(
      a => {
        console.debug('on notif service : ', _payload, a, data);
        console.debug('on notif service [0] : ', JSON.stringify(data));
        // if (a) {
        //   console.debug('on notif service [1] : ', JSON.stringify(a));
        // }
        if (a?.length) {
          a.forEach(notf => {
            if (notf.notification && !notf.title) {
              _payload.push({
                title: notf?.notification?.title,
                body: notf?.notification?.body,
              });
            } else _payload.push(notf);
          });
          // _payload.push(...a); //_payload.push(a);
        }
        if (data?.payload) _payload.push(data.payload);
        else if (data?.notification && !data.title) {
          _payload.push({
            title: data?.notification?.title,
            body: data?.notification?.body,
          });
        } else _payload.push(data);
        this.storage.setPreference('notifications', _payload).subscribe(() => {
          this.setHasNotification(true);
        });

        // console.debug('on notif service : ', _payload, a);
      },
      error => {},
      () => {
        // this.storeToLocal(data.payload,_payload)
      }
    );
    this.handler.handle(data, appActive);
  }

  private storeToLocal(payload: any, exPayload: any) {
    // OSNotificationPayload
    let _payload = payload;
    exPayload.push(_payload);
    this.storage.setPreference('notifications', exPayload);
    // notification: OSNotification, appActive: boolean

    let pushData: any = _payload.additionalData;
    let title: string = _payload.title;
    let message: string = _payload.body;
    let notificationType = pushData.type;
    // let activePage       = view.isLast();

    // let page: any        = view._cmp.instance;
  }

  initFCM() {
    this.registerNotifications();
    this.firebaseRegisterNotifications();
    PushNotifications.requestPermissions().then(result => {
      if (result.receive === 'granted') {
        PushNotifications.register();
      }
    });

    PushNotifications.addListener('registration', (token: Token) => {
      console.log('📲 FCM token [1]:', token.value);
      console.log('📲 FCM token [2]:', JSON.stringify(token));
      this.flightService.notfRegisterToken(token.value).subscribe(
        data => {
          console.debug('success fcm token register : ', data);
        },
        error => {
          console.debug('error fcm : ', JSON.stringify(error));
        }
      );
      // 👉 You can also send this to your backend
    });

    PushNotifications.addListener(
      'pushNotificationReceived',
      (notification: PushNotificationSchema) => {
        console.log('📩 FCM notification received:', notification);
        MessageDisplayUtil.showMessageToast(
          notification?.title,
          this.platform,
          this.toastCtrl,
          5000,
          'bottom'
        );
      }
    );

    PushNotifications.addListener('pushNotificationActionPerformed', (action: ActionPerformed) => {
      console.log('🎯 FCM action:', JSON.stringify(action.notification));
      MessageDisplayUtil.showMessageToast(
        action.notification?.title + ' [2] ',
        this.platform,
        this.toastCtrl,
        5000,
        'bottom'
      );
    });
  }

  registerNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();

    if (permStatus.receive === 'prompt') {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== 'granted') {
      throw new Error('User denied permissions!');
    }

    await PushNotifications.register();
    console.debug(
      'Firebase - FCM listing channels : ',
      JSON.stringify(PushNotifications.listChannels())
    );
  };

  getDeliveredNotifications = async () => {
    const notificationList = await PushNotifications.getDeliveredNotifications();
    console.log('delivered notifications', notificationList);
  };

  async firebaseRegisterNotifications() {
    // Request permission
    const permStatus = await FirebaseMessaging.requestPermissions();
    if (permStatus.receive !== 'granted') {
      console.warn('Push permission not granted');
      return;
    }

    // Register for token
    const token = await FirebaseMessaging.getToken();
    console.log('FCM Token:', token.token);

    this.flightService.notfRegisterToken(token.token).subscribe(
      data => {
        console.debug('success fcm token register : ', data);
      },
      error => {
        console.debug('error fcm : ', JSON.stringify(error));
      }
    );

    // Save this token to your backend
    // Test with Firebase Console using this token

    // Request permission
    // await FirebaseMessaging.register();

    // Listeners
    FirebaseMessaging.addListener('notificationReceived', event => {
      const _msg: any = event?.notification; // JSON.stringify(event);
      if (!_msg?._dateTime) _msg._dateTime = null;
      _msg._dateTime = {
        date: moment().format('YYYY-MM-DD'),
        time: moment().format('HH:mm:ss'),
      };
      console.log('Notification received [notf]:', event, JSON.stringify(_msg));

      this.onNotification(_msg, true);
      let _message = `${_msg?.title} - ${_msg?.body}`;
      MessageDisplayUtil.showMessageToast(_message, this.platform, this.toastCtrl, 5000, 'bottom');
    });

    FirebaseMessaging.addListener('notificationActionPerformed', event => {
      const _msg: any = event?.notification; // JSON.stringify(event);
      if (!_msg?._dateTime) _msg._dateTime = null;
      _msg._dateTime = {
        date: moment().format('YYYY-MM-DD'),
        time: moment().format('HH:mm:ss'),
      };
      console.log('Notification tapped [notf]:', event, JSON.stringify(_msg));
    });

    //     le: https://localhost/main.js - Line 129439 -
    // Msg: Not÷ification received [notf]: [object Object]
    const msg = {
      notification: {
        id: '0:1758523773805082%98ae90d798ae90d7',
        data: {},
        title: 'Test notf capture',
        body: 'Pilot test messaging',
        tag: 'campaign_collapse_key_3186244098615317088',
      },
    };
    // 2025-09-22 14:49:34.607  7778-7855  EGL_emulation           com.brite.wagc                       D  ap
  }

  setNotfMessage(msg: any, appActive: boolean) {
    console.debug('setting notf message : ', msg);
    this.onNotification(msg, appActive);
  }
}
